import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Api from "../../services/Api";
import { VisionStatementInterface } from "../DevelopmentPlan/interfaces";
import { Modal, ModalHeader, ModalBody } from "../../components/Modal";
import Loading from "../../components/Loading";
import Stepper from "../../components/Stepper";
import SelfAssessmentRecipientPage from "./SelfAssessmentRecipientPage";
import SelfAssessmentSurveyResponse from "./SelfAssessmentSurveyResponse";
import SelfAssessmentSurveyCreation from "./SelfAssessmentSurveyCreation";
import {useTranslation} from "react-i18next";
import {getLanguage} from "../../lang/helpers";

const SelfAssessmentSurveyPage = () => {
  const api = Api.getInstance();
  const { id } = useParams<{ id: string }>();
  const { t, i18n } = useTranslation();
  const lang = getLanguage(i18n.language);
  const [visionStatement, setVisionStatement] = useState<VisionStatementInterface | null>(null);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(0);
  const [showEditQuestions, setShowEditQuestions] = useState<boolean>(false);
  const [longTermGoalInfoModel, setLongTermGoalInfo] = useState(false);
  const [allDone, setAllDone] = useState<boolean>(false);
  const stepsData = [
    { title: t("self-assessment"), content: null },
    { title: "Feedback", content: null }
  ];

  const getData = () => {
    api.get('client/vision_statement_own_survey/' + id).then(response => {
      if (response.json.status === "ok") {
        setVisionStatement(response.json.visionStatement);
        setLoading(false);
      } else {
        alert("Error: " + response.json.status);
        console.log(response.json.error)
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (visionStatement?.surveyId && visionStatement.surveyRequests[0].surveyResult.scoreSelf > 0) {
      setStep(1);
    }
  }, [visionStatement])


  if (loading || !visionStatement) {
    return <Loading txt={lang === 'sv' ? 'Hämtar din självskattning, det kan ta ett tag' : 'Loading your self-assessment, this may take a while'}/>;
  }

  const renderContent = () => {
    if (visionStatement.surveyRequests[0].surveyResult.scoreSelf > 0) {
      return <SelfAssessmentRecipientPage visionStatement={visionStatement} done={() => setAllDone(true)} />
    } else if (showEditQuestions) {
      return <SelfAssessmentSurveyCreation visionStatement={visionStatement} save={() => getData()}
                                           showDetailModal={() => setLongTermGoalInfo(true)}
                                           close={() => setShowEditQuestions(false)}/>
    } else {
      return <SelfAssessmentSurveyResponse visionStatement={visionStatement} save={() => getData()}
                                           showDetailModal={() => setLongTermGoalInfo(true)}
                                           setEdit={() => setShowEditQuestions(true)} />
    }
  }

  const renderLongTermGoalInfoInfoModel = () => {
    return (
      <Modal isOpen={longTermGoalInfoModel} onClose={() => setLongTermGoalInfo(false)}>
        <ModalHeader onClose={() => setLongTermGoalInfo(false)}>
          {t("long-term-goal-details")}
        </ModalHeader>
        <ModalBody>
          <div className="mt-2 font-medium text-gray-100">Title:</div>
          <div className="text-gray-300">{visionStatement.title}</div>

          <div className="mt-2 font-medium text-gray-100">{t("description")}:</div>
          <div className="text-gray-300">{visionStatement.description}</div>

          <div className="mt-2 font-medium text-gray-100">{t("due-date")}:</div>
          <div className="text-gray-300">{visionStatement.deadline}</div>
        </ModalBody>
      </Modal>
    );
  };

  return (
    <div className="main-content p-4">
      {
        !allDone &&
        <>
          <Stepper
              steps={stepsData}
              direction="horizontal"
              currentIndex={step}
              completedSteps={step === 1 ? [0] : []}
          />
          <hr className="mt-1 border-indigo-700" />
        </>
      }

      {renderContent()}
      {
        longTermGoalInfoModel && renderLongTermGoalInfoInfoModel()
      }
    </div>
  );
};

export default SelfAssessmentSurveyPage;